/*
* author ivanm
*/
define(function (require) {
    "use strict";

    var LE = require("app");
    var LEConfig = require("assets/config/le-env-conf");
    var template = require("registration-templates/registrationSignUpView.tmpl");
    var Button = require("ui/button/Button");
    var RegistrationSignUpView = {};
    var InputField = require("ui/input-field/InputField");
    var Loader = require("ui/loader/Loader");
    var Bubble = require("ui/bubble/Bubble");
    var RegistrationLeadModel = require("registration-models/RegistrationLeadModel");
    var RegistrationSignUpModel = require("registration-models/RegistrationSignUpModel"); //Deprecated
    var ValidationUtilities = require("utils/ValidationUtilities");
    var Config = require("registration-assets/config/config.json");
    var errorCodes = require("registration-assets/data/errorCodes.json");
    var XRegExp = require("xregexp").XRegExp;

    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        var COMPONENTS = {
           EMAIL_INPUT: "emailInput"
        };

        var ERRORS = {
            EMAIL_INVALID: "emailAddressInvalid"
        };

        var mapErrorToComponent = {};
        mapErrorToComponent[ERRORS.EMAIL_INVALID] = COMPONENTS.EMAIL_INPUT;

        var that;

        RegistrationSignUpView = Marionette.ItemView.extend({

            className: 'registration-sign-up-view',

            template: template,

            withUIComponents: true,

            initialize: function () {
                LERegistration.logger.info("RegistrationSignUpView >> initialize >> START");
                this.button = null;
                this.model.set('oneSeat',LEConfig.Billing.oneSeatEnabled);
                LERegistration.logger.info("RegistrationSignUpView >> initialize >> END");
            },

            ui: {
                registrationEmailAddressDiv: ".email-address-div",
                registrationLetGetStartedButton: ".let-get-started-button",
                registrationLoginButton: ".footer-panel-sign-in-button"
            },

            uiComponents: {
                getStartedButton: {
                    type: Button,
                    options: {
                        el: "view.ui.registrationLetGetStartedButton",
                        permutation:Button.PERMUTATION.BTN_PRIMARY,
                        initState:Button.STATES.ENABLED,
                        tabindex: 2,
                        onClick : registrationLetsGetStarted
                    }
                },

                emailInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.registrationEmailAddressDiv",
                        permutation : InputField.Permutation.B,
                        tabindex: 1,
                        autoFocus: true
                    }
                },

                loginButton: {
                    type: Button,
                    options: {
                        el: "view.ui.registrationLoginButton",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_onLoginButtonClicked"
                    }
                }
            },

            events: {
                'keypress input': 'keyPressEnter'
            },

            keyPressEnter: function (ev) {
                if(ev.keyCode == 13) { // Enter
                    $('.let-get-started-button .btn-primary').focus();
                    //this.ui.registrationLetGetStartedButton.focus();
                    LERegistration.logger.info("RegistrationSignUpView >> keyPressEnter >> ENTER pressed");
                    this.registrationLetGetStarted(ev);
                }
            },

            onInvalid: function(model, errors) {
                LERegistration.logger.info("RegistrationSignUpView >> onInvalid >> START");
                this.loader.close();
                cleanAllErrorBubbles();
                LERegistration.notifier.showError(LE.translator.translate("LEFramework.errors.generalError.on.page"));
                setAllErrorBubbles(errors);
                LERegistration.logger.info("RegistrationSignUpView >> onInvalid >> END");
            },

            onRender: function () {
                LERegistration.logger.info("RegistrationSignUpView >> onRender >> START");
                that = this;
                this.listenTo(this.uiComponents.emailInput, InputField.TRIGGERING.CHANGE, this.updateEmail);
                var inputFieldUIComponents= this.uiComponents.emailInput;
                setTimeout(function () {
                    inputFieldUIComponents.setFocus(true);
                }, 0);
                LERegistration.logger.info("RegistrationSignUpView >> onRender >> END");
            },

            updateEmail : function(email){
                email= email.replace(/\+|\s|=/g, "");
                var inputFieldUIComponents= this.uiComponents.emailInput;
                inputFieldUIComponents.setValue(email);
                this.model.set('email', email);
            },

            doValidate: function(){
                LERegistration.logger.info("RegistrationSignUpView >> doValidate >> START");
                var errors = {};
                _.extend(errors, this.validateEmail());

                if (_.isEmpty(errors)){
                    LERegistration.logger.info("RegistrationSignUpView >> doValidate >> is valid");
                    return false;
                }else{
                    LERegistration.notifier.showError(LE.translator.translate("LEFramework.errors.generalError.on.page"));
                    LERegistration.logger.info("RegistrationSignUpView >> doValidate >> has errors >> errors=" + errors);
                    return errors;
                }
                LERegistration.logger.info("RegistrationSignUpView >> doValidate >> END");
            },

            validateEmail: function(){
                LERegistration.logger.info("RegistrationSignUpView >> validateLastName >> START");
                var errors = {};
                if (ValidationUtilities.isEmpty(this.uiComponents.emailInput.getValue())){
                    errors[ERRORS.EMAIL_INVALID] = LE.translator.translate("LERegistration.FieldMandatory");

                }else if(!XRegExp.call(this, Config.validators.email.regex).test(this.uiComponents.emailInput.getValue())) {
                    //TODO: consider replacing regex with w3c http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
                    errors[ERRORS.EMAIL_INVALID] = LE.translator.translate("LERegistration.PleaseEnterValidEmail");
                }
                LERegistration.logger.info("RegistrationSignUpView >> validateEmail >> END");
                return errors;
            },

            registrationLetGetStarted: function (ev) {
                LERegistration.logger.info("RegistrationSignUpView >> registrationLetGetStarted >> START");
                var that = this;
                this.loader = new Loader({
                    permutation: Loader.PERMUTATION.A,
                    el: '.registration-region'
                }).render();

                var errors = this.doValidate();
                if (errors){
                    LERegistration.logger.info("RegistrationCreateAccountView >> registrationCreateAccount >> has errors >> errors=" + errors);
                    this.onInvalid(null, errors);
                } else {
                    var registrationLeadModel = new RegistrationLeadModel();
                    registrationLeadModel.set("email", this.model.get("email"));
                    registrationLeadModel.set("language",this.model.get("emailLanguage"));
                    registrationLeadModel.set("campaignSearchKeywords",this.model.get("campaignSearchKeywords"));
                    registrationLeadModel.set("campaignSource",this.model.get("campaignSource"));
                    registrationLeadModel.set("campaignReferrer",this.model.get("campaignReferrer"));
                    registrationLeadModel.set("campaignId",this.model.get("campaignId"));
                    registrationLeadModel.set("roiaValue",this.model.get("roiaValue"));

                    var leadOptions = {
                        success: _.bind(function () {
                            LERegistration.logger.info("success", "RegistrationSignUpView >> createTryLead");
                        },this),
                        error: function (model, response) {
                            var message= "SignUp Lead failed to be saved. No action in client side taken.";
                            var errorCode= errorCodes.signUpLeadApiFailed + ((response && response.responseError && (response.responseError.code || response.responseError.errorCode)) || response.status) + ".";
                            message+= ".error code: " + errorCode;
                            message+= ".server said: " + ((response && response.responseError && response.responseError.message) || response.statusText);
                            LERegistration.logger.error(message, "RegistrationSignUpView:createTryLead");
                        }
                    };

                    //TODO(oded): add roia cookie value as a param
                    registrationLeadModel.save(null, leadOptions);

                    this.model.unset("campaignSearchKeywords");
                    this.model.unset("campaignSource");
                    this.model.unset("campaignReferrer");
                    this.model.unset("campaignId");
                    this.model.unset("roiaValue");
                    this.model.unset('oneSeat');
                    var options = {
                        success: function () {
                            LERegistration.logger.info("model save success", "RegistrationSignUpView:registrationLetGetStarted");
                            that.loader.close();
                            LERegistration.logger.info("RegistrationSignUpView >> registrationLetGetStarted >> navigate >> signingUp");
                            LERegistration.controller.trialController.showThankYouView();
                        },
                        error: function (model, response) {
                            var message= "SignUp contact email verification API failed upon save.";
                            var errorCode= errorCodes.signUpApiFailed;
                            var returnPage= "signUp";

                            LERegistration.logger.error(message, "RegistrationSignUpView:registrationLetGetStarted");
                            LERegistration.controller.handleRegistrationError(message, errorCode, returnPage, null, response);
                            that.loader.close();
                        }
                    };
                    this.model.save(null, options);
                    LERegistration.logger.info("RegistrationSignUpView >> registrationLetGetStarted >> request sent");
                    LERegistration.logger.info("RegistrationSignUpView >> registrationLetGetStarted >> END");
                }
            },

            _onLoginButtonClicked: function() {
                LE.logout();
            }
        });

        function cleanAllErrorBubbles(){
            LERegistration.logger.info("RegistrationSignUpView >> cleanAllErrorBubbles >> START");
            for(var error in COMPONENTS) {
                that.uiComponents[COMPONENTS[error]].setError(false);
            }
            LERegistration.logger.info("RegistrationSignUpView >> cleanAllErrorBubbles >> END");
        }

        function setAllErrorBubbles(errors){
            LERegistration.logger.info("RegistrationSignUpView >> setAllErrorBubbles >> START");
            for(var error in errors) {
                that.uiComponents[mapErrorToComponent[error]].setError(true, errors[error] );
            }
            LERegistration.logger.info("RegistrationSignUpView >> setAllErrorBubbles >> END");
        }

        function registrationLetsGetStarted (e) {
            that.registrationLetGetStarted(e);
        }

    });
    return RegistrationSignUpView;
});
